export const APPLICATION = 'Application';
export const SIDE_PANEL_CATEGORY_USR = 'User';
export const SIDE_PANEL_CATEGORY_RLE = 'Role';
export const SIDE_PANEL_CATEGORY_ACC = 'Account';
export const SIDE_PANEL_CATEGORY_ENT = 'Entitlement';
export const SIDE_PANEL_CATEGORY_CHILD_ENT = 'Child Entitlement';

export const CERT_ENTITLEMENT_VALUEKEY = 'CERT_ENTITLEMENT_VALUEKEY';
export const CERT_EO_ROW_TYPE = 'ROW_TYPE';

export const USR_TITLE_FOR_SIDE_PANEL = 'User_DISPLAYNAME';
export const USR_DESCRIPTION_FOR_SIDE_PANEL = 'User description';
export const RLE_TITLE_FOR_SIDE_PANEL = 'Role_DISPLAYNAME';
export const RLE_DESCRIPTION_FOR_SIDE_PANEL = 'LASTCERTIFIEDCAMPAIGNNAME';
export const ACC_TITLE_FOR_SIDE_PANEL = 'Account_DISPLAYNAME';
export const ACC_DESCRIPTION_FOR_SIDE_PANEL = 'Account_DESCRIPTION';
export const ENT_TITLE_FOR_SIDE_PANEL = 'Ent_DISPLAYNAME';
export const ENT_DESCRIPTION_FOR_SIDE_PANEL = 'Ent_DESCRIPTION';

export const EO_FIXED_COL_FOR_ACCOUNT = 'DEFAULTACCOUNTNAME';
export const EO_FIXED_COL_FOR_ENTITLEMENT = 'DEFAULTENTITLEMENTNAME';
export const EO_FIXED_COL_FOR_CHILD_ENTITLEMENT = 'DEFAULTENTITLEMENT2NAME';
export const CHILD_ENT_DESCRIPTION_FOR_SIDE_PANEL = 'Ent2_DESCRIPTION';

export const TAB_SUMMARY = 'tab_summary';
export const TAB_HISTORY = 'tab_history';
export const TAB_PRIVILEGE = 'tab_privilege';
export const TAB_ENTITLEMENT = 'tab_entitlement';
export const TAB_CHILDREN = 'tab_children';
export const TAB_DEPENDENT = 'tab_dependent';
export const TAB_SOD = 'tab_sod';
export const TAB_MENU = 'tab_menu';
